/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/RadioButton',['pixi', 'absolute', 'lodash'],

    function (PIXI, Absolute, _) {

        var RadioButton = function (options) {

            var defaultOptions = {
                label: '',
                selected: false,
                letterStyle: {
                    font: Absolute.ScreenMetrics.getResScale() * 23 + 'px Arial',
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'left'
                },
                radio: 'radio_off.png',
                radioDot: 'toggle_dot.png'
            };

            this._initRadioButton(_.extend(defaultOptions, options));
        };

        RadioButton.constructor = RadioButton;
        RadioButton.prototype = Object.create(PIXI.Sprite.prototype);

        RadioButton.prototype._initRadioButton = function (options) {

            this.options = options;

            this.container = new PIXI.DisplayObjectContainer();


            this.value = this.options.value;
            this.selected = this.options.selected;
            this.label = Absolute.StringManager(this.options.label);
            this.id = this.options.label;
            this.value = this.options.value;

            this.upTexture = this._createTexture('up');
            this.overTexture = this._createTexture('over');
            this.downTexture = this._createTexture('down');
            this.selectedTexture = this._createTexture('selected');

            PIXI.Sprite.call(this, this.selected ? this.selectedTexture : this.upTexture);

            this.interactive = true;
            this.buttonMode = true;

            this.focusIndicator = new PIXI.Graphics();
            this.focusIndicator.lineStyle(1, 0xFFFFFF);
            var margin = Absolute.Coords.x(-2);
            this.focusIndicator.drawRect(margin, margin, this.width - 2 * margin, this.height - 2 * margin);

            this.hitArea = new PIXI.Rectangle(0, 0, this.width * 1.2, this.height * 1.2);


            if (Absolute.Platform.supportsTouch()) {

                this.touchstart = function (evt) {
                    this.handleAction();
                };

                // Support mouse on laptops/desktops that have touch displays
                if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
                    this.bindMouseEvents();
                }

            } else {
                this.bindMouseEvents();
            }
        };

        RadioButton.prototype.bindMouseEvents = function () {

            this.mouseover = function (evt) {
                if (this.selected) {
                    this.setTexture(this.selectedTexture);
                } else {
                    this.setTexture(this.overTexture);
                }
            };

            this.mouseout = function (evt) {
                if (this.selected) {
                    this.setTexture(this.selectedTexture);
                } else {
                    this.setTexture(this.upTexture);
                }
            };

            this.mousedown = function (evt) {
                this.setTexture(this.downTexture);
            }.bind(this);

            this.mouseup = function (evt) {
                this.handleAction();
            }.bind(this);
        };

        RadioButton.prototype.handleAction = function () {
            Absolute.AudioManager.playSound('button');
            this.options.action(this.id);
        };

        RadioButton.prototype.select = function () {
            this.selected = true;
            this.setTexture(this.selectedTexture);
        };

        RadioButton.prototype.deselect = function () {
            this.selected = false;
            this.setTexture(this.upTexture);
        };

        RadioButton.prototype._createTexture = function (type) {

            var container = new PIXI.DisplayObjectContainer(),
                radio = PIXI.Sprite.fromFrame(this.options.radio),
                label = new PIXI.Text(this.label, this.options.letterStyle),
                texture;
            radio.scale.set(1.2, 1.2);

            label.x = radio.width + Absolute.Coords.x(10);
            label.y = radio.y + Absolute.Coords.y(3) + (radio.height - label.height) / 2;

            container.addChild(label);
            container.addChild(radio);

            if (type === 'selected') {
                var radioDot = PIXI.Sprite.fromFrame(this.options.radioDot);
                radioDot.scale.set(1.4, 1.4);
                radioDot.x = radio.x + (radio.width - radioDot.width) / 2;
                radioDot.y = radio.y + (radio.height - radioDot.height) / 2;
                radio.tint = 0x4091be;
                container.addChild(radioDot)
            }

            texture = container.generateTexture();

            if (type === 'over' || type === 'down') {
                texture = Absolute.SpriteUtils.brightness(texture, 0.2);
            }

            return texture;
        };

        RadioButton.prototype.handleActivate = function () {
            this.handleAction();
        };

        RadioButton.prototype.destroy = function () {
        };

        RadioButton.prototype._focusChanged = function () {
            if (this._hasFocus) {
                this.addChild(this.focusIndicator);
            } else {
                if (this.children.indexOf(this.focusIndicator) != -1) {
                    this.removeChild(this.focusIndicator);
                }
            }
        };

        Object.defineProperty(RadioButton.prototype, "focus", {
            get: function () {
                return this._hasFocus;
            },
            set: function (value) {
                this._hasFocus = value;
                this._focusChanged();
                return value;
            }
        });


        return RadioButton;

    });

